import { render, staticRenderFns } from "./DeleteScoreReportModal.vue?vue&type=template&id=4bfdf561&scoped=true&"
import script from "./DeleteScoreReportModal.vue?vue&type=script&lang=js&"
export * from "./DeleteScoreReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfdf561",
  null
  
)

export default component.exports